var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPharoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196.645,
    height: 53.77,
    viewBox: "0 0 196.645 53.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3350",
    "data-name": "Rectangle 3350",
    width: 196.645,
    height: 53.77,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pharo-logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4520",
    "data-name": "Group 4520",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M.444.843H15.9c2.66,0,6.1.106,8.083,2.943a8.684,8.684,0,0,1,1.382,4.927,7.713,7.713,0,0,1-1.7,5.14c-2.056,2.481-5.069,2.623-8.295,2.623H6.613v9.43H.444ZM6.613,12.081h7.728c2.02,0,4.785-.035,4.785-3.368a3.58,3.58,0,0,0-1.064-2.766c-.85-.744-1.771-.744-4.4-.744H6.613Z",
    transform: "translate(-0.04 -0.077)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M43.89.882h6.274v9.642H65.3V.882h6.274V25.911H65.3V15.169H50.164V25.911H43.89Z",
    transform: "translate(-3.997 -0.081)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M101.295.883h6.771L120.154,25.91h-7.019L111.009,21.2H98.175L96.049,25.91H89.207Zm3.97,7.692a5.975,5.975,0,0,1-.425-.993,4.488,4.488,0,0,1-.213-.993c-.106.319-.177.6-.248.886-.142.319-.248.638-.39.957l-3.793,8.33h8.791Z",
    transform: "translate(-8.124 -0.081)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M138.036.883h17.228c2.837,0,5.424.247,7.515,2.659a7.4,7.4,0,0,1,1.632,4.821A6.9,6.9,0,0,1,162,13.892a9.514,9.514,0,0,1-4.077,1.56l7.587,10.458h-7.373l-6.7-10.068H144.31V25.91h-6.274Zm6.274,10.528h10c1.346,0,3.757-.177,3.757-2.978a3.549,3.549,0,0,0-.5-1.95c-.461-.6-1.063-1.205-3.544-1.205H144.31Z",
    transform: "translate(-12.571 -0.081)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M210.574,4.878a12.854,12.854,0,0,1,2.694,8.189c0,7.976-5.176,13.577-15.279,13.577s-15.455-5.494-15.455-13.293c0-8.615,6.168-12.975,14.392-13.329,4.927-.213,10.529,1.063,13.648,4.856m-21.589,8.615a8.164,8.164,0,0,0,1.6,5.246c.6.851,2.446,3.438,7.3,3.438,5.85,0,8.969-3.97,8.969-8.791a8.571,8.571,0,0,0-9.217-8.863c-4.184.143-8.65,2.908-8.65,8.969",
    transform: "translate(-16.624 0)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M191.768,47.532v6.033l1.97,1.6,3.906-2.831Z",
    transform: "translate(-17.465 -4.329)",
    fill: "#59c4e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M210.556,41.436v6.479l-8.72,6.694h-7.9Z",
    transform: "translate(-17.662 -3.774)",
    fill: "#0065b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M0,44.416H4.554a2.844,2.844,0,0,1,3.186,3.07,2.837,2.837,0,0,1-3.186,3.069H1.381V54.8H0Zm1.382,4.976H4.087c1.557.015,2.27-.669,2.27-1.906s-.713-1.906-2.27-1.906H1.381Z",
    transform: "translate(0 -4.045)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M13.139,47.377c2.386,0,3.652,1.732,3.652,3.943s-1.266,3.928-3.652,3.928S9.487,53.517,9.487,51.32s1.266-3.943,3.652-3.943m0,6.78c1.3,0,2.342-1.018,2.342-2.837s-1.047-2.851-2.342-2.851S10.8,49.487,10.8,51.32s1.048,2.837,2.342,2.837",
    transform: "translate(-0.864 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M26.292,55.091H24.983l-1.528-5.98h-.029l-1.513,5.98H20.574L18.159,47.57h1.368l1.7,6.153h.029l1.512-6.153h1.353L25.7,53.723h.029l1.687-6.153h1.281Z",
    transform: "translate(-1.654 -4.333)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M37.207,52.688a3.033,3.033,0,0,1-3.216,2.56c-2.4,0-3.535-1.659-3.608-3.957a3.621,3.621,0,0,1,3.535-3.914c2.663,0,3.478,2.488,3.4,4.307H31.693a2.216,2.216,0,0,0,2.342,2.473,1.812,1.812,0,0,0,1.95-1.469Zm-1.193-2.1a2.161,2.161,0,0,0-4.321,0Z",
    transform: "translate(-2.767 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M39.167,47.552H40.33v1.586h.029a2.736,2.736,0,0,1,2.765-1.761v1.31c-1.993,0-2.721,1.134-2.721,3.04v3.346H39.167Z",
    transform: "translate(-3.567 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M50.422,52.688a3.033,3.033,0,0,1-3.216,2.56c-2.4,0-3.535-1.659-3.608-3.957a3.621,3.621,0,0,1,3.535-3.914c2.663,0,3.478,2.488,3.4,4.307H44.908a2.216,2.216,0,0,0,2.342,2.473,1.812,1.812,0,0,0,1.95-1.469Zm-1.193-2.1a2.161,2.161,0,0,0-4.321,0Z",
    transform: "translate(-3.971 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M59.112,54.8H57.875V53.786h-.029a2.531,2.531,0,0,1-2.4,1.193c-2.313,0-3.462-1.833-3.462-3.957s1.134-3.914,3.433-3.914a2.878,2.878,0,0,1,2.43,1.179h.029v-3.87h1.237Zm-3.492-.917c1.659,0,2.3-1.425,2.3-2.837,0-1.484-.669-2.851-2.371-2.851s-2.255,1.44-2.255,2.909c0,1.412.728,2.779,2.328,2.779",
    transform: "translate(-4.734 -4.045)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M66,44.416h1.237V48.3h.029a2.532,2.532,0,0,1,2.4-1.193c2.313,0,3.462,1.833,3.462,3.957s-1.134,3.914-3.433,3.914a2.878,2.878,0,0,1-2.43-1.179h-.029v1H66ZM69.49,48.2c-1.659,0-2.3,1.425-2.3,2.837,0,1.484.669,2.851,2.371,2.851s2.255-1.44,2.255-2.909c0-1.412-.727-2.779-2.328-2.779",
    transform: "translate(-6.011 -4.045)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M78.1,56.095c-.568,1.469-1.077,2.008-2.182,2.008a2.446,2.446,0,0,1-.859-.132V56.836a2.544,2.544,0,0,0,.728.175,1.068,1.068,0,0,0,1.018-.684l.509-1.28-2.982-7.479h1.4l2.2,6.154h.029l2.11-6.154h1.309Z",
    transform: "translate(-6.77 -4.333)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M87.486,44.416H92.04a2.845,2.845,0,0,1,3.187,3.07,2.837,2.837,0,0,1-3.187,3.069H88.868V54.8H87.486Zm1.382,4.976h2.706c1.557.015,2.27-.669,2.27-1.906s-.713-1.906-2.27-1.906H88.868Z",
    transform: "translate(-7.968 -4.045)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M97.374,47.552h1.163v1.586h.029a2.736,2.736,0,0,1,2.765-1.761v1.31c-1.993,0-2.721,1.134-2.721,3.04v3.346H97.374Z",
    transform: "translate(-8.868 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M108.63,52.688a3.033,3.033,0,0,1-3.216,2.56c-2.4,0-3.535-1.659-3.608-3.957a3.621,3.621,0,0,1,3.535-3.914c2.663,0,3.478,2.488,3.4,4.307h-5.631a2.216,2.216,0,0,0,2.342,2.473,1.812,1.812,0,0,0,1.95-1.469Zm-1.193-2.1a2.161,2.161,0,0,0-4.321,0Z",
    transform: "translate(-9.272 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M117.32,54.8h-1.237V53.786h-.029a2.53,2.53,0,0,1-2.4,1.193c-2.313,0-3.463-1.833-3.463-3.957s1.135-3.914,3.433-3.914a2.877,2.877,0,0,1,2.43,1.179h.029v-3.87h1.237Zm-3.491-.917c1.658,0,2.3-1.425,2.3-2.837,0-1.484-.669-2.851-2.37-2.851s-2.256,1.44-2.256,2.909c0,1.412.728,2.779,2.329,2.779",
    transform: "translate(-10.035 -4.045)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M121.234,45.929H120V44.416h1.236ZM120,47.282h1.236V54.8H120Z",
    transform: "translate(-10.929 -4.045)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M128.329,49.967a1.75,1.75,0,0,0-1.862-1.5c-1.79,0-2.342,1.411-2.342,2.939,0,1.382.625,2.749,2.2,2.749a1.944,1.944,0,0,0,2.066-1.832h1.266a3.128,3.128,0,0,1-3.317,2.925c-2.3,0-3.521-1.6-3.521-3.841s1.163-4.031,3.549-4.031c1.7,0,3.07.8,3.244,2.59Z",
    transform: "translate(-11.185 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M133.283,47.344h1.5v1.091h-1.5v4.671c0,.567.16.669.931.669h.567v1.091h-.945c-1.28,0-1.789-.262-1.789-1.643V48.435h-1.281V47.344h1.281V45.089h1.236Z",
    transform: "translate(-11.909 -4.107)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M140.942,44.416h1.382v4.466h5.47V44.416h1.383V54.8h-1.383V50.046h-5.47V54.8h-1.382Z",
    transform: "translate(-12.836 -4.045)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M158.436,52.688a3.032,3.032,0,0,1-3.215,2.56c-2.4,0-3.535-1.659-3.607-3.957a3.621,3.621,0,0,1,3.535-3.914c2.662,0,3.478,2.488,3.4,4.307h-5.63a2.216,2.216,0,0,0,2.342,2.473,1.812,1.812,0,0,0,1.95-1.469Zm-1.193-2.1a2.161,2.161,0,0,0-4.321,0Z",
    transform: "translate(-13.808 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M167.068,55.045a1.66,1.66,0,0,1-.888.2c-.64,0-1.047-.35-1.047-1.164a3.339,3.339,0,0,1-2.648,1.164c-1.368,0-2.488-.612-2.488-2.11,0-1.7,1.265-2.066,2.545-2.313,1.368-.262,2.532-.175,2.532-1.106,0-1.077-.887-1.251-1.673-1.251-1.048,0-1.818.319-1.877,1.425h-1.236c.073-1.862,1.513-2.517,3.186-2.517,1.353,0,2.822.306,2.822,2.066v3.87c0,.582,0,.843.394.843a1.065,1.065,0,0,0,.378-.073ZM165.06,51.19a6.392,6.392,0,0,1-2.241.509c-.814.145-1.513.436-1.513,1.353,0,.814.7,1.105,1.455,1.105,1.63,0,2.3-1.018,2.3-1.7Z",
    transform: "translate(-14.571 -4.315)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3349",
    "data-name": "Rectangle 3349",
    width: 1.236,
    height: 10.388,
    transform: "translate(153.526 40.371)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M173.811,47.344h1.5v1.091h-1.5v4.671c0,.567.159.669.93.669h.567v1.091h-.945c-1.28,0-1.789-.262-1.789-1.643V48.435h-1.281V47.344h1.281V45.089h1.237Z",
    transform: "translate(-15.6 -4.107)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M177.005,44.416h1.236v3.972h.03a2.546,2.546,0,0,1,2.371-1.281c1.979,0,2.59,1.135,2.59,2.75V54.8H182V49.711a1.417,1.417,0,0,0-1.527-1.512,2.115,2.115,0,0,0-2.227,2.357V54.8h-1.236Z",
    transform: "translate(-16.12 -4.045)",
    fill: "#1a1818"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharoLogo);
export default __webpack_public_path__ + "static/media/pharo-logo.821a7703e623c2a33c6bf1a9405e1dca.svg";
export { ForwardRef as ReactComponent };